<template>
    <div>
        <ClinicDialog ref="clinicDialog" @updated="updateTable"/>

        <header>
          <button :disabled="matchAllBtnDisabled" tooltip=" medflex:match_all_clinics" @click.prevent="match_all()">
            Cматчить клиники
          </button>
          <button :disabled="isUpdateBtnDisabled" @click.prevent="callLPUListUpdate()">
            Обновить lpu list
          </button>
          <button :disabled="isCallScheduleBtnDisabled" @click.prevent="callScheduleUpdate()">
            Обновить расписание
          </button>
          <button :disabled="matchDoctorsBtnDisabled" @click.prevent="callMatchDoctors()">
            Cматчить врачей
          </button>
        </header>

        <v-table id="appointmentsClinicsTable"
                 request-uri="onlineAppointments/getClinicsList"
                 pagesize="50"
                 :lazycount="true"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="70">
                        Созд
                    </v-th>
                    <v-th name="clinic_medflex" sort="clinic_name" minwidth="170">
                        Клиника МЕДФЛЕКС
                    </v-th>
                    <v-th name="clinic_doctu" sort="clinic_doctu" minwidth="170">
                        Клиника ДОКТУ
                    </v-th>
                    <v-th name="subscription_tariff" width="100">
                        Тариф
                    </v-th>
                    <v-th name="status" width="150">
                        Статус
                    </v-th>
                    <v-th name="refreshBtn" width="70" tooltip="Запросить вручную список врачей">
                      Обновить
                    </v-th>
                    <v-th name="whiteList" width="70" tooltip="Белый лист для Lead интегр, которые мы выдаем медфлексу">
                      БелЛист
                    </v-th>
                    <v-th name="doctorsNotMatched" width="70" tooltip="Количество врачей Медфлекс, не связанных с анкетой Докту">
                        ВрНеСвяз
                    </v-th>
                    <v-th name="doctorsMatched" width="70" tooltip="Количество врачей Медфлекс, связанных с анкетой Докту">
                        ВрСвяз
                    </v-th>
                    <v-th name="doctorsWithSchedule" width="70" tooltip="Количество врачей Медфлекс, связанных с анкетой Докту и имеющих расписание">
                        Расп
                    </v-th>
                    <v-th name="updated_at" sort="updated_at" width="70">
                        Обновлен
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinic_medflex" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinic_doctu" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="subscription_tariff" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "* Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Без тарифа"
                                },
                                {
                                    value: "ABONEMENT",
                                    text: "Подписка Стандарт"
                                },
                                {
                                    value: "ABONEMENT_PLUS",
                                    text: "Подписка Премиум"
                                },
                                {
                                    value: "ONLY_LK",
                                    text: "Личный кабинет"
                                },
                                {
                                    value: "LK_NET",
                                    text: "Личный кабинет сети"
                                },
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="status" v-slot="{ filter }">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                    ...v_s_convert(statuses)
                                ]'
                        ></v-select>
                    </v-th>
                    <v-th name="refreshBtn"/>
                    <v-th name="whiteList"/>
                    <v-th name="doctorsNotMatched"/>
                    <v-th name="doctorsMatched"/>
                    <v-th name="doctorsWithSchedule"/>
                    <v-th name="updated_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover"
                      :class="{pointer: item.status !== 'DELETED'}"
                      :id="'mc-tr-' + item.id"
                      @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="created_at" highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="clinic_medflex">
                        <b>{{ item.clinic_name }}</b>
                        <template v-if="item.address">
                            <br>
                            <span>{{ item.address }}</span>
                        </template>
                    </v-td>
                    <v-td name="clinic_doctu">
                        <template v-if="item.clinic">
                            <b>{{ item.clinic.name }}</b>
                            <template v-if="item.clinic.address && item.clinic.cityObj">
                                <br>
                                <span>г. {{ item.clinic.cityObj.name }}, {{ item.clinic.address }}</span>
                            </template>
                        </template>
                    </v-td>
                    <v-td name="subscription_tariff" highlight="*">
                        {{ tariffs[item.subscription_tariff ?? ''] }}
                    </v-td>
                    <v-td name="status" highlight="*" align="center">
                        <span v-html="getStatus(item)"></span>
                    </v-td>
                  <v-td name="refreshBtn" align="center">
                    <i v-if="item.clinic_id !== null && item.in_lpu_list !== 0" class="fas fa-download" @click.prevent.stop="refreshDoctors(item)"></i>
                  </v-td>
                  <v-td name="whiteList" align="center">
                    <span>{{ item.in_white_list }}</span>
                  </v-td>
                  <v-td name="doctorsNotMatched" align="center">
                        <span>{{ item.doctorsNotMatched }}</span>
                    </v-td>
                    <v-td name="doctorsMatched" align="center">
                        <span>{{ item.doctorsMatched }}</span>
                    </v-td>
                    <v-td name="doctorsWithSchedule" align="center">
                        <span>{{ item.doctorsWithSchedule }}</span>
                    </v-td>
                    <v-td name="updated_at" highlight="*">
                        {{ item.updated_at | formatDate }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </div>
</template>

<script>
import ClinicDialog from "@dialogs/admin/onlineAppointments/Clinic";

export default {
    components: {
        ClinicDialog
    },
    data: function () {
        return {
            isUpdateBtnDisabled: false,
            matchAllBtnDisabled: false,
            isCallScheduleBtnDisabled: false,
            matchDoctorsBtnDisabled: false,
            statuses: {
                '': '',
                'OFF_MEDFLEX': 'Откл. в МФ',
                'OFF_OUR': 'Откл у нас',
                'NOT_MATCHED': 'Нет связи',
                'ON': 'Готово',
            },
            tariffs: {
                '': '',
                'ABONEMENT': 'Подписка Стандарт',
                'ABONEMENT_PLUS': 'Подписка Премиум',
                'ONLY_LK': 'Личный кабинет',
                'LK_NET': 'Личный кабинет сети',
            },
        };
    },
    methods: {
      refreshDoctors (item) {
        this.axios
            .post('onlineAppointments/clinic/'+item.id+'/refreshDoctors')
            .then(response => {
              this.$modal('Врачи стянуты ('+ response.data.doctorsNotMatched + '|' + response.data.doctorsMatched+'|' + response.data.doctorsWithSchedule+ ')'
                  ,{
                name: 'ОК',
                callback: () => {},
              },{}, false, 'only-text-dialog');
              item.doctorsNotMatched = response.data.doctorsNotMatched
              item.doctorsMatched = response.data.doctorsMatched
              item.doctorsWithSchedule= response.data.doctorsWithSchedule
            });
      },
        getStatus(item){
          if (item.clinic_id === null){
            return 'Нет связи'
          }
          if (item.in_lpu_list === -1){
            return 'Откл. в МФ'
          }

          if (item.in_lpu_list === 0){
            if(item.integration_type === 'LEAD' && item.subscription_tariff !== null){
              return "Выключена<br/> (LEAD + есть подписка)"
            }
            if(item.integration_type === 'LEAD' && item.in_white_list===0){
              return "Выключена<br/>(нет в whitelist)"
            }
            if(item.integration_type === 'INDIVIDUAL' && item.individual_off_manual_at !== null ){
              return "Выключена вручную"
            }

            return 'Выключена'
          }
          if (item.in_lpu_list === 1){
            return 'Готово'
          }
        },
        match_all(){
          this.matchAllBtnDisabled = true;
          this.axios
              .post('onlineAppointments/matchAll')
              .then(response => {
                if (response.data.status === 'success') {
                  this.$modal('Обновление запущено',{
                    name: 'ОК',
                    callback: () => {},
                  },{}, false, 'only-text-dialog');
                }
              });
        },
      callMatchDoctors() {
        this.matchDoctorsBtnDisabled = true;

        this.axios
            .post('onlineAppointments/callMatchDoctors')
            .then(response => {
              if (response.data.status === 'success') {
                this.$modal('Обновление запущено',{
                  name: 'ОК',
                  callback: () => {},
                },{}, false, 'only-text-dialog');
              }
            });
      },
      callScheduleUpdate() {
        this.isCallScheduleBtnDisabled = true;

        this.axios
            .post('onlineAppointments/callScheduleUpdate')
            .then(response => {
              if (response.data.status === 'success') {
                this.$modal('Обновление запущено',{
                  name: 'ОК',
                  callback: () => {},
                },{}, false, 'only-text-dialog');
              }
            }).catch(err => {
            let msg = err.message;
            if(err.errors && err.errors.common){
              msg = err.errors.common[0]
            }
            this.$modal(msg,{
              name: 'ОК',
              callback: () => {},
            },{}, false, 'only-text-dialog');
            });
      },
      callLPUListUpdate() {
            this.isUpdateBtnDisabled = true;

            this.axios
                .post('onlineAppointments/callLPUListUpdate')
                .then(response => {
                    if (response.data.status === 'success') {
                        this.$modal('Обновление запущено',{
                            name: 'ОК',
                            callback: () => {},
                        },{}, false, 'only-text-dialog');
                    }
                });
        },
        handleRowClick(event, item, row) {
            if (item.status === 'DELETED') {
                return;
            }

            row.startLoadingAnimation();

            this.$refs.clinicDialog.show(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        updateTable() {
            this.$refs.table.update();
        }
    }
}
</script>

<style>
#appointmentsClinicsTable {
    height: calc(100vh - 185px);
}
</style>
